import { memo } from '../../lib/teact/teact';

import useLang from '../../hooks/useLang';

import Loading from '../ui/Loading';

const AuthMiniAppLoading = () => {
  const lang = useLang();

  return (
    <div id="auth-miniapp-loading" className="custom-scroll">
      <div className="auth-form">
        <div id="logo" />
        <h1>{lang('MiniAppAuthLoading')}</h1>
        <div className="auth-loading-spinner">
          <Loading />
        </div>
      </div>
    </div>
  );
};

export default memo(AuthMiniAppLoading);
